module.exports = __webpack_public_path__ + "img/step4_wechatpay@3x.c2eb04be.png";